// Others — Government, CSR, Implementation Partners & Other Organisations
// Figma frames: 113:3 (Overview), 114:2 (Partnership Models)

export const PARTNERS_NAV = [
  { label: 'Overview',            to: '/partners' },
  { label: 'Partnership Models',  to: '/partners/models' },
];

export const PARTNERS_CTA = {
  primary:   { label: 'Discuss Partnership', to: '/partnership-request' },
  secondary: { label: 'Project Overview',    to: '/partners' },
};

export const PARTNERS_FOOTER = {
  brandNote: 'Conceptualized, designed and developed by Dr. Keyur Sorathia & team at the Embedded Interaction Lab, Department of Design, IIT Guwahati.',
  cols: [
    { title: 'Partnerships', items: [
      { label: 'Overview',              to: '/partners' },
      { label: 'Partnership Models',    to: '/partners/models' },
      { label: 'Discuss Partnership',   to: '/partnership-request' },
    ]},
    { title: 'Who can partner', items: [
      { label: 'Government programmes',      to: '/partners' },
      { label: 'CSR deployments',            to: '/partners' },
      { label: 'Implementation partnerships',to: '/partners' },
    ]},
  ],
};

// 33 Government CSR & Partners Overview — 113:3
export const PARTNERS_OVERVIEW = {
  hero: {
    eyebrow: 'PARTNERSHIPS FOR SCALE',
    title:   'Bring immersive learning to more students',
    desc:    'Government departments, CSR programmes, implementation partners and other organisations can work with Gyan Dhara to enable responsible, curriculum-aligned deployment at scale.',
    ctaPrimary:   { label: 'Explore Partnership Models', to: '/partners/models' },
    ctaSecondary: { label: 'Discuss Partnership',        to: '/partnership-request' },
    imageLabel:  'PARTNER  →  DEPLOY  →  LEARN',
  },
  strip: [
    { k: 'DEVELOPED AT',  v: 'Dr. Keyur Sorathia & team at the Embedded Interaction Lab, Department of Design, IIT Guwahati' },
    { k: 'CURRENT FOCUS', v: 'Grade 8–9 Science and Mathematics' },
    { k: 'LANGUAGES',     v: 'English · Hindi · Assamese' },
    { k: 'OPERATION',     v: 'Offline-first' },
    { k: 'EVIDENCE',      v: 'Field evaluation underway' },
  ],
  who: {
    eyebrow: 'WHO CAN PARTNER',
    title:   'Different organisations, one shared objective',
    desc:    'Partnerships can be structured around public access, CSR impact, implementation capacity or specialised expertise.',
    items: [
      { title: 'Government departments',   desc: 'State, district or institutional programmes that want structured school deployment.',     color: 'purple', icon: 'Landmark' },
      { title: 'CSR and foundations',      desc: 'Organisations funding equitable access to hardware, logistics and implementation.',       color: 'royal',  icon: 'Heart' },
      { title: 'Implementation partners',  desc: 'Regional partners supporting coordination, training, installation and field operations.', color: 'cyan',   icon: 'Handshake' },
      { title: 'Other organisations',      desc: 'Education, research, technology or social-impact organisations with a relevant contribution.', color: 'mint',   icon: 'Network' },
    ],
  },
  why: {
    eyebrow: 'WHY GYAN DHARA',
    title:   'Learning access with a larger national purpose',
    desc:    'The programme connects conceptual clarity and experiential learning with the broader goal of developing future innovators, problem solvers and scientists for Viksit Bharat.',
    items: [
      { title: 'Scale meaningful learning', desc: 'Extend difficult Science and Mathematics concepts beyond diagrams and lectures.',              color: 'purple', icon: 'TrendingUp' },
      { title: 'Reach diverse learners',    desc: 'Support government, semi-private and private institutions without restricting module access.',  color: 'royal',  icon: 'Users2' },
      { title: 'Build responsible evidence',desc: 'Combine implementation with structured evaluation and transparent reporting.',                  color: 'cyan',   icon: 'ClipboardCheck' },
      { title: 'Strengthen local capacity', desc: 'Prepare coordinators, teachers, IT staff and student champions for sustained use.',              color: 'mint',   icon: 'GraduationCap' },
    ],
  },
  pathways: {
    eyebrow: 'PARTNERSHIP MODELS',
    title:   'Choose the contribution pathway',
    desc:    'The partnership can focus on funding, programme ownership, implementation or domain expertise.',
    items: [
      { n: '1', title: 'Public programme',            desc: 'Government-led deployment across selected schools or districts.',                             color: 'purple' },
      { n: '2', title: 'CSR-supported deployment',    desc: 'CSR partner funds hardware, logistics and agreed implementation support.',                    color: 'royal' },
      { n: '3', title: 'Implementation partnership',  desc: 'A partner coordinates onboarding, installation, training and local operations.',              color: 'cyan' },
      { n: '4', title: 'Strategic collaboration',     desc: 'An organisation contributes research, technology, accessibility or specialised content expertise.', color: 'mint' },
    ],
  },
  ecosystem: {
    eyebrow: 'WHAT THE PROGRAMME INCLUDES',
    title:   'A complete educational ecosystem',
    desc:    'Every approved deployment receives the same Gyan Dhara software ecosystem; the programme scale does not change the content entitlement.',
    items: [
      { title: 'Curriculum VR modules', desc: 'NCERT-aligned Grade 8–9 Science and Mathematics modules.',           color: 'purple', icon: 'Boxes' },
      { title: 'Exploration',           desc: 'Space, history, art, nature and interdisciplinary experiences.',      color: 'royal',  icon: 'Compass' },
      { title: 'Assessment',            desc: 'Unlimited conceptual, theoretical and applied quizzes.',              color: 'cyan',   icon: 'ClipboardList' },
      { title: 'Analytics',             desc: 'Completion, time spent, chapter activity and quiz performance.',      color: 'mint',   icon: 'BarChart3' },
      { title: 'Gyan Mitra',            desc: 'English, Hindi and Assamese Q&A when internet is available.',         color: 'purple', icon: 'MessageCircle' },
      { title: 'Updates',               desc: 'New modules and software updates through June 2027.',                 color: 'royal',  icon: 'RefreshCw' },
    ],
  },
  context: {
    eyebrow: 'CURRENT IMPLEMENTATION CONTEXT',
    title:   'From Assam to broader deployment',
    desc:    'The platform is currently being implemented and evaluated in Assam while the multilingual, offline-first architecture supports deployment across India.',
    metrics: [
      { k: '60',   label: 'Schools planned',  note: 'Adarsh Vidyalaya deployment target' },
      { k: '8–9',  label: 'Grades',           note: 'Science and Mathematics' },
      { k: '3',    label: 'Languages',        note: 'English, Hindi and Assamese' },
      { k: '2027', label: 'Access period',    note: 'No software licence fee through June' },
    ],
    mediaTitle: 'Field deployment overview',
  },
  portfolio: {
    eyebrow: 'LEARNING MODULE PORTFOLIO',
    title:   'Modules available for programme deployment',
    desc:    'The same learning portfolio is available across approved deployments. Upcoming modules will be added through the software update cycle.',
    availableLabel: 'AVAILABLE NOW',
    upcomingLabel:  'IN DEVELOPMENT / UPCOMING',
    availableNow: [
      { title: "Gravity's Grip",         subject: 'Science' },
      { title: 'Friction',                subject: 'Science' },
      { title: 'Work',                    subject: 'Science' },
      { title: 'Energy',                  subject: 'Science' },
      { title: 'Falltopia',               subject: 'Science' },
      { title: 'AeroQuest',               subject: 'Science' },
      { title: 'Human Excretory System',  subject: 'Science' },
    ],
    upcoming: [
      { title: 'Structure of Atoms',            subject: 'Science' },
      { title: 'Area of Cone',                  subject: 'Mathematics' },
      { title: 'Area of Sphere',                subject: 'Mathematics' },
      { title: 'Volume of Sphere and Cone',     subject: 'Mathematics' },
      { title: 'Contact & Non-contact Forces',  subject: 'Science' },
      { title: 'Light',                          subject: 'Science' },
    ],
  },
  boundaries: {
    eyebrow: 'CLEAR CONTRIBUTION BOUNDARIES',
    title:   'Software access and programme funding',
    desc:    'Gyan Dhara does not charge a software licence fee through June 2027. Hardware, accessories, configuration, shipping, training, support and implementation are funded through the programme arrangement.',
    included: {
      title: 'Included software ecosystem',
      items: 'VR modules · learning website · quizzes · analytics · new releases · software updates',
    },
    funded: {
      title: 'Programme-funded components',
      items: 'Headsets · straps · stools · setup · courier · optional training · support · maintenance',
    },
  },
  cta: {
    title:   'Discuss a programme, CSR deployment or implementation partnership.',
    primary: { label: 'Discuss Partnership', to: '/partnership-request' },
  },
};

// 34 Partnership Models — 114:2
export const PARTNERSHIP_MODELS = {
  hero: {
    eyebrow: 'PARTNERSHIP MODELS',
    title:   'Choose a model that matches the contribution',
    desc:    'The partnership structure depends on who owns the programme, who funds deployment, who manages implementation and what outcomes need to be monitored.',
    ctaPrimary: { label: 'Discuss Partnership', to: '/partnership-request' },
    flow: ['OWN', 'FUND', 'IMPLEMENT'],
    flowNote: 'A clear programme agreement defines responsibilities, funding, implementation and reporting.',
  },
  models: {
    eyebrow: 'FOUR PARTNERSHIP MODELS',
    title:   'Different roles, shared learning outcomes',
    desc:    'Models can be adapted, but ownership and responsibility should remain explicit.',
    items: [
      { letter: 'G', title: 'Government-led programme',  desc: 'Government identifies institutions, enables approvals and coordinates public-system implementation.', role: 'PROGRAMME OWNER',  color: 'purple' },
      { letter: 'C', title: 'CSR-supported deployment',  desc: 'CSR or foundation funds hardware, logistics and agreed implementation or support.',                     role: 'FUNDING PARTNER',  color: 'royal' },
      { letter: 'I', title: 'Implementation partnership',desc: 'Regional partner manages onboarding, installation, training, operations and issue escalation.',        role: 'DELIVERY PARTNER', color: 'cyan' },
      { letter: 'S', title: 'Strategic collaboration',   desc: 'Research, technology, accessibility or content organisation contributes specialised expertise.',        role: 'KNOWLEDGE PARTNER',color: 'mint' },
    ],
  },
  roles: {
    eyebrow: 'ROLE CLARITY',
    title:   'Who does what',
    desc:    'A partnership agreement should define programme decisions, funding, technical preparation and local operations.',
    headers: ['Responsibility', 'Programme / Funding Partner', 'Implementation Partner', 'Gyan Dhara Team'],
    rows: [
      ['Institution identification', 'Lead / approve',              'Support locally',        'Provide readiness criteria'],
      ['Hardware and logistics',     'Fund / procure through plan', 'Coordinate delivery',    'Configure and prepare'],
      ['Accounts and software',      'Provide data and approvals',  'Collect verified information', 'Create, install and update'],
      ['Training and operations',    'Approve operating model',     'Coordinate local team',  'Provide agreed remote training'],
      ['Monitoring and reporting',   'Define programme indicators', 'Support data collection','Provide system summaries'],
      ['Research evaluation',        'Enable permissions',          'Support field execution','Design and analyse as agreed'],
    ],
  },
  standard: {
    eyebrow: 'MINIMUM DEPLOYMENT STANDARD',
    title:   'A consistent baseline for responsible use',
    desc:    'The same minimum standard applies regardless of funding source or organisation type.',
    items: [
      { k: '3+',    label: 'Headsets',            desc: 'Minimum three Meta Quest 3S headsets per deployment.',           color: 'purple' },
      { k: '20',    label: 'Learners per headset',desc: 'Recommended planning ratio across the academic year.',           color: 'royal' },
      { k: '1:1',   label: 'During use',          desc: 'One learner uses one headset at a time.',                        color: 'cyan' },
      { k: '35–45', label: 'Minutes',             desc: 'Typical curriculum-module session duration.',                    color: 'mint' },
      { k: 'OFF',   label: 'Core operation',      desc: 'Installed modules work offline.',                                color: 'purple' },
      { k: '12+',   label: 'Learner age',         desc: 'Preferably for students aged 12 and above.',                     color: 'royal' },
    ],
  },
  pathway: {
    eyebrow: 'IMPLEMENTATION PATHWAY',
    title:   'From intent to active deployment',
    desc:    'A programme can begin after scope, responsibilities, agreement and applicable funding are confirmed.',
    steps: [
      { n: '1', title: 'Define programme',     desc: 'Geography, institutions, learners and objectives.',            color: 'purple' },
      { n: '2', title: 'Confirm readiness',    desc: 'Hardware standard, coordinators, permissions and connectivity.', color: 'royal' },
      { n: '3', title: 'Agree responsibilities', desc: 'Funding, setup, training, support, evaluation and reporting.',  color: 'cyan' },
      { n: '4', title: 'Configure and dispatch', desc: 'Prepare headsets, accounts, software and accessories.',         color: 'mint' },
      { n: '5', title: 'Launch and monitor',   desc: 'Begin sessions, review operations and resolve issues.',           color: 'purple' },
    ],
  },
  monitoring: {
    eyebrow: 'MONITORING AND EVIDENCE',
    title:   'Report what is ready, not what is assumed',
    desc:    'Programme reporting should separate system activity, operational observations, preliminary learning patterns and validated research findings.',
    items: [
      { letter: 'A', title: 'System activity',       desc: 'Modules started and completed, time spent and quiz performance.',   color: 'purple' },
      { letter: 'O', title: 'Operational indicators',desc: 'Device readiness, session completion and support requirements.',    color: 'royal' },
      { letter: 'P', title: 'Preliminary findings', desc: 'Early patterns shared with context and limitations.',                color: 'cyan' },
      { letter: 'E', title: 'Validated evidence',   desc: 'Published only after analysis, review and appropriate permissions.', color: 'mint' },
    ],
  },
  cta: {
    title:   'Build a partnership model with clear ownership and responsibilities.',
    desc:    'Share your proposed programme scale, geography and contribution to begin the discussion.',
    primary: { label: 'Discuss Partnership', to: '/partnership-request' },
  },
};

// 35 Partnership Discussion Request — 115:2
export const PARTNERSHIP_REQUEST = {
  hero: {
    eyebrow: 'DISCUSS PARTNERSHIP',
    title:   'Start a government, CSR or implementation discussion',
    desc:    'Share the organisation, proposed geography, programme scale and expected contribution. The Gyan Dhara team will respond within 48 hours to discuss feasibility and next steps.',
    readinessTitle: 'A useful request includes',
    readiness: [
      'Organisation type and mandate',
      'Proposed geography and institution count',
      'Expected contribution or implementation role',
      'Indicative timeline and decision process',
      'Primary programme objective',
    ],
  },
  formTitle: 'Partnership request',
  formHint:  'All fields marked * are required.',
  orgTypes:  ['Government', 'CSR or foundation', 'Implementation partner', 'Other organisation'],
  interests: [
    'Government-led programme',
    'CSR-funded deployment',
    'Implementation partnership',
    'Research or evidence collaboration',
    'Technology or accessibility contribution',
  ],
  agreements: [
    'I understand that software access and programme-funded hardware or implementation costs are separate.',
    'I agree to be contacted to discuss this partnership request.',
  ],
  submit: 'Submit Partnership Request',
  submitNote: 'The request will be sent to keyur.sorathia@gyan-dhara.com',
  privacy:    'Information is used only to respond to this request and support the agreed programme.',
  nextTitle:  'What happens next',
  next: [
    { title: 'Initial review',         desc: 'Organisation, geography and contribution' },
    { title: 'Discovery discussion',   desc: 'Objectives, readiness and programme scale' },
    { title: 'Partnership design',     desc: 'Roles, funding, implementation and reporting' },
    { title: 'Agreement and planning', desc: 'Scope, timeline, responsibilities and permissions' },
  ],
  readinessTitle: 'Readiness indicators',
  readinessItems: [
    { letter: 'S', title: 'Defined scope', desc: 'Geography and programme objective.',        color: 'purple' },
    { letter: 'R', title: 'Clear role',    desc: 'Ownership, funding or implementation.',      color: 'royal' },
    { letter: 'P', title: 'Permissions',   desc: 'Institutional and research requirements.',   color: 'cyan' },
    { letter: 'T', title: 'Timeline',      desc: 'Decision and launch expectations.',          color: 'mint' },
  ],
  confirmation: {
    title: 'Request received',
    body:  'The request is under review. The Gyan Dhara team will respond within 48 hours.',
    cta:   { label: 'Return to Partnership Overview', to: '/partners' },
  },
};
